import axios from 'axios'
import { getBFFUrl, getToken } from './requests'

export const getVivaWalletPaymentInfo = async (data, isRecurring) => {
  const token = await getToken()

  const vvw = {
    amount: isRecurring ? 100 : data.amount,
    customerTrns: isRecurring ? 'Portal Balsas: Recurring Payment (1.00€)' : 'Portal Balsas Debt Settling',
    customer: {
      email: data?.email,
      fullName: data?.name,
      countryCode: 'BR',
      requestLang: 'pt-BR',
    },
    paymentTimeout: 600,
    preauth: false,
    allowRecurring: isRecurring,
    maxInstallments: 12,
    paymentNotification: false,
    tipAmount: 0,
    disableExactAmount: false,
    disableCash: true,
    disableWallet: true,
    sourceCode: parseInt(process.env.REACT_APP_VVW_SOURCE_CODE),
    merchantTrns: isRecurring ? 'Portal Balsas: Recurring Payment (1.00€)' : 'Portal Balsas Debt Settling',
    tags: [isRecurring ? 'balsas-add-card' : 'balsas-settle-debt'],
  }

  const res = await axios.post(
    `${getBFFUrl()}/payment`,
    { vvw, trips: data?.trips, operator: 'BALSAS' },
    {
      headers: {
        'x-access-token': token,
        operator: 'DemoBalsas',
      },
    }
  )

  return res.data
}

export const settleUnpaidTrips = async (amount, transactionID, cardUniqueReference, trips) => {
  const token = await getToken()

  const vvw = {
    amount,
    customerTrns: trips ? 'Portal Balsas Debt Settling' : 'Portal Balsas Hora Marcada',
  }

  const card = {
    transactionID,
    cardUniqueReference
  }

  const res = await axios.post(
    `${getBFFUrl()}/transaction`,
    { vvw, card, trips, operator: 'BALSAS' },
    {
      headers: {
        'x-access-token': token,
        operator: 'DemoBalsas',
      },
    }
  )

  return res.data
}
